import React from "react";
import TextField from "@material-ui/core/TextField";
import Modal from "components/Tvendo/Common/ModalBase";

export default function ModalPriceList(props) {
  const priceList = props.model;

  return (
    <Modal
      title="Lista de precios"
      model={priceList}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="logi/price-list"
    >
      <TextField
        label="Nombre"
        fullWidth
        name="ListName"
        margin="normal"
        defaultValue={!!priceList ? priceList.ListName : ""}
        required
      />
      <TextField
        label="Número base"
        type="number"
        fullWidth
        name="BASE_NUM"
        margin="normal"
        defaultValue={!!priceList ? priceList.BASE_NUM : ""}
      />
      <TextField
        type="number"
        label="Factor"
        fullWidth
        name="Factor"
        margin="normal"
        defaultValue={!!priceList ? priceList.Factor : ""}
        inputProps={{ step: 0.01, min: 0 }}
      />
    </Modal>
  );
}
